import React from 'react';
import PropTypes from 'prop-types';
import {CANCEL_TEXT, ENABLE_DISABLE_DIALOG} from '../../Constants/strings.js';
import FormDialogContent from '../../Components/FormDialogContent/formDialogContent.js';

const EnableDisableCategoryDialog = ({
  handleCloseAction,
  selectedRow,
  handleEnableDisableAction,
  setIsDialogOpen,
  isDialogOpen,
  setRows,
  handleSnackbar,
  setIsEdit,
  content,
}) => {
  const contentData = content || (selectedRow.isActive ? ENABLE_DISABLE_DIALOG.DISABLE : ENABLE_DISABLE_DIALOG.ENABLE);

  return (
    <FormDialogContent
      open={isDialogOpen}
      title={contentData}
      cancelButtonId={'cancel-' + contentData.BUTTON_ID}
      submitButtonId={contentData.BUTTON_ID}
      button1={CANCEL_TEXT}
      button2={contentData.BUTTON_TEXT}
      button1Action={() => handleCloseAction(setIsDialogOpen, setIsEdit)}
      button2Action={() =>
        handleEnableDisableAction(
          selectedRow,
          setRows,
          setIsDialogOpen,
          handleSnackbar,
          setIsEdit,
        )
      }
    />
  );
};

EnableDisableCategoryDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleEnableDisableAction: PropTypes.func.isRequired,
  selectedRow: PropTypes.object,
  setIsDialogOpen: PropTypes.func.isRequired,
  setRows: PropTypes.func.isRequired,
  handleSnackbar: PropTypes.func.isRequired,
  setIsEdit: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
  isDialogOpen: PropTypes.bool.isRequired,
};

export default EnableDisableCategoryDialog;
